/**
 * PricingHeader - Displays "7 Days Free" and billing badge
 *
 * Shows trial pricing with annual billing amount
 */

interface PricingHeaderProps {
  /** Whether this is a trial offer */
  isTrial?: boolean;
  /** Annual price in dollars */
  annualPrice?: number;
  /** Whether pricing is loading */
  isLoading?: boolean;
}

export function PricingHeader({
  isTrial = true,
  annualPrice = 119,
  isLoading = false,
}: PricingHeaderProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center gap-2">
        <div className="h-10 w-32 animate-pulse rounded-lg bg-slate-200" />
        <div className="h-6 w-48 animate-pulse rounded-full bg-slate-200" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center gap-2">
      {/* Main pricing */}
      <div className="text-center">
        {isTrial ? (
          <h2 className="text-4xl font-bold text-catch-dark-blue-90">
            7 Days Free
          </h2>
        ) : (
          <h2 className="text-4xl font-bold text-catch-dark-blue-90">
            ${annualPrice}
            <span className="text-lg font-normal text-slate-500">/year</span>
          </h2>
        )}
      </div>

      {/* Billing badge */}
      {isTrial && (
        <div className="inline-flex items-center gap-1.5 rounded-full bg-catch-dark-blue-90 px-3 py-1.5">
          <img
            src="/images/icons/payment-page-v2/icon-clock.svg"
            alt=""
            className="h-4 w-4 brightness-0 invert"
          />
          <span className="text-sm font-medium text-white">
            then ${annualPrice}/year
          </span>
        </div>
      )}
    </div>
  );
}

export default PricingHeader;
